var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"rules":_vm.rules ? _vm.rules : _vm.customRules,"label":_vm.showAsterisk ? _vm.label : null,"prop":_vm.prop}},[_c('FInput',{attrs:{"title":!_vm.showAsterisk ? _vm.label : null,"value":_vm.value,"type":"password","placeholder":_vm.placeholder,"bordered":_vm.bordered,"show-password":""},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }